import { Ng2StateDeclaration } from '@uirouter/angular';

import { NoContentComponent } from './noContent/noContent.component';
import { resolveLoadUser } from './auth/resolves/loadUser.resolve';

/** The top level state(s) */
export let APP_STATES: Ng2StateDeclaration[] = [
  {
    name: '404',
    component: NoContentComponent
  },
  {
    name: 'main',
    abstract: true,
    params: {
      auth: {
        redirect: false,
        from: null
      }
    },
    resolve: [
      resolveLoadUser
    ]
  }
];



// WEBPACK FOOTER //
// ./src/app/app.states.ts